import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { useApiContext } from '@trg/api';
import type {
  RelatedSearchApiParams,
  RelatedSearchApiResponse,
} from './relate-search-data-api.type';
import { request } from '../../common';

export const relatedSearchDataApiPath = '/headerfooter/relatedSearchData';

export function useRelatedSearchDataApi(
  params: RelatedSearchApiParams,
  options?: Pick<UseQueryOptions<RelatedSearchApiResponse>, 'onSuccess'>
) {
  const { host } = useApiContext();
  if (host === undefined) throw new Error('ApiContext not found');

  return useQuery({
    queryKey: ['relatedSearch', params],
    queryFn: async () => {
      const response = await request<RelatedSearchApiResponse>({
        method: 'get',
        url: relatedSearchDataApiPath,
        params,
        devHost: true,
      });
      return response;
    },
    enabled: Boolean(params.k),
    ...options,
  });
}
